<template>
  <div class="container">
    <headerDiv />
    <div class="bg-color">
      <div class="middler-wrapper">
        <sideDiv />
        <mainDiv />
         <!-- <sideDivone /> -->
      </div>
    </div>
   
    <footerDiv />
  </div>
</template>

<script>
import headerDiv from "./header";
import sideDiv from "./side";
import mainDiv from "./main";
import footerDiv from "./footer";
// import sideDivone from "./sideone";
export default {
  components: {
    headerDiv,
    sideDiv,
    mainDiv,
    footerDiv,
    // sideDivone
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  .bg-color {
    background-color: #e8e8e8;
    // @include backgroundColor($bg-wrapper);
    width: 100%;
    .middler-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      padding: 20px 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/layout/index.vue